var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnaroundCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1935_130120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.04102,
    y: -3.11719,
    width: 46.2329,
    height: 46.2329,
    fill: "#161C27"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.6709 14.917C15.1027 14.917 14.6421 14.4564 14.6421 13.8882C14.6421 13.32 15.1027 12.8594 15.6709 12.8594L23.9013 12.8594C26.1741 12.8594 28.0166 14.7018 28.0166 16.9746C28.0166 19.2474 26.1741 21.0898 23.9013 21.0898H15.6709C14.5345 21.0898 13.6133 22.0111 13.6133 23.1474C13.6133 24.2838 14.5345 25.2051 15.6709 25.2051H24.9301C25.4983 25.2051 25.959 25.6657 25.959 26.2339C25.959 26.8021 25.4983 27.2627 24.9301 27.2627H15.6709C13.3981 27.2627 11.5557 25.4202 11.5557 23.1474C11.5557 20.8747 13.3981 19.0322 15.6709 19.0322H23.9013C25.0377 19.0322 25.959 18.111 25.959 16.9746C25.959 15.8382 25.0377 14.917 23.9013 14.917H15.6709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4272 16.2515C17.829 16.6533 17.829 17.3047 17.4272 17.7065C17.0254 18.1082 16.374 18.1082 15.9722 17.7065L12.8858 14.62C12.484 14.2183 12.484 13.5669 12.8858 13.1651L15.9722 10.0787C16.374 9.6769 17.0254 9.6769 17.4272 10.0787C17.829 10.4804 17.829 11.1319 17.4272 11.5336L15.0682 13.8926L17.4272 16.2515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1434 28.5992C21.7416 29.0009 21.7416 29.6523 22.1434 30.0541C22.5451 30.4559 23.1965 30.4559 23.5983 30.0541L26.6847 26.9677C27.0865 26.5659 27.0865 25.9145 26.6847 25.5127L23.5983 22.4263C23.1965 22.0246 22.5451 22.0246 22.1434 22.4263C21.7416 22.8281 21.7416 23.4795 22.1434 23.8813L24.5023 26.2402L22.1434 28.5992Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.924657,
    y: 0.924657,
    width: 38.1507,
    height: 38.1507,
    rx: 19.0753,
    stroke: "#DDE1E9",
    strokeWidth: 1.84931
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1935_130120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnaroundCircle);
export default __webpack_public_path__ + "static/media/turnaround-circle.48914ddfc0a39adc389079c8fb3b916e.svg";
export { ForwardRef as ReactComponent };